/**
 * Copyright (c) 20250321, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 */

const base = {
    logo : 'logo.png',
    icons: 'https://akademy.ma/Content/Icons/',
    app_url : 'https://akademy.ma',
    api_url : 'https://api.akademy.ma',
    domain: 'moshaf.akademy.ma',
    name: 'Moshaf',
    service:1
}

const contact = {
    theme: {
        red : {c:'rgb(102,0,0)', bc:'rgb(153,0,0)', bgc:'rgba(234,153,153,0.5)'},
        blue : {c:'rgb(7,55,99)', bc:'rgb(11,83,148)', bgc:'rgba(159,197,232,0.5)'},
        orange : {c:'rgb(120,63,4)', bc:'rgb(180,95,6)', bgc:'rgba(249,203,156,0.5)'},
        green : {c:'rgb(39,78,19)', bc:'rgb(56,118,29)', bgc:'rgba(182,215,168,0.5)'}
    }
}

const icons = {
    add : base.icons+'add.png',
    reload : base.icons+'reload.png',
    minimize : base.icons+'minimize.png',
    maximize : base.icons+'maximize.png',
    search : base.icons+'search.png'
}

const bank = {
    Company: 'TECH2US',    
    RIB : '366 810 0117109 100050838 01',
    Name: 'BANK AL YOUSR',
}

export {base, contact, icons}
